import React, { useState, useEffect } from "react";
import { AppContent, AppSideDrawer } from "../components/index";
import Navbar from "../components/AppBar";
import QuickLinks from "../components/QuickLinks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faBox,
  faBoxes,
  faCartFlatbed,
  faChartLine,
  faCodePullRequest,
  faGift,
  faList,
  faListCheck,
  faPerson,
  faSquarePlus,
  faTriangleExclamation,
  faTruckRampBox,
  faUserAstronaut,
  faUserPlus,
  faUserShield,
  faUserTie,
  faWarehouse,
  faTachometerAlt,
  faTools,
  faHandshake,
  faDollarSign,
  faLayerGroup,
  faLandmark,
  faSync,
  faTruckFast,
  faBullhorn,
  faFileInvoice,
  faBuilding,
  faTags,
} from "@fortawesome/free-solid-svg-icons";
import { useStores } from "../../use-stores";
import { EmployeeRoles } from "../../models/Employees/EmployeeRoles";
import { useLocation } from "react-router-dom";
import {
  faComments,
  faFileAlt,
  faPenToSquare,
} from "@fortawesome/free-regular-svg-icons";

const DefaultLayout = () => {
  const { userStore } = useStores();
  const location = useLocation();
  const [open, setOpen] = useState(true);
  useEffect(() => {
    if (location.pathname === "/project-management/ops-sync") {
      setOpen(false);
    } else if (location.pathname.startsWith("/project-management/listing")) {
      setOpen(true);
    } else if (
      location.pathname.includes("/swagstore/create-store") ||
      location.pathname.includes("/swagstore/preview")
    ) {
      setOpen(false);
    } else if (location.pathname.includes("/swagstore/listing")) {
      setOpen(true);
    }
  }, [location.pathname]);

  const menus: any = [];

  menus.push({
    title: "Dashboard",
    path: "",
    icon: <FontAwesomeIcon icon={faChartLine} fontSize={14} />,
  });

  if (
    userStore.hasPermission([EmployeeRoles.VIEW_CUSTOMER_EXPERIENCE_DASHBOARD])
  ) {
    menus.push({
      title: "Cust. Exp Dashboard",
      path: "/customer-experience-dashboard",
      icon: <FontAwesomeIcon icon={faPenToSquare} fontSize={14} />,
      subTitle: [
        {
          title: "Overview",
          path: "/",
          icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_FINANCE_DASHBOARD])) {
    menus.push({
      title: "Finance Dashboard",
      path: "/finance-dashboard",
      icon: <FontAwesomeIcon icon={faLandmark} fontSize={14} />,
      subTitle: [
        {
          title: "Overview",
          path: "/",
          icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_LOGISTICS_DASHBOARD])) {
    menus.push({
      title: "Logistics Dashboard",
      path: "/logistics-dashboard",
      icon: <FontAwesomeIcon icon={faTruckFast} fontSize={14} />,
      subTitle: [
        {
          title: "Overview",
          path: "/",
          icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_NPS_DASHBOARD])) {
    menus.push({
      title: "NPS Dashboard",
      path: "/nps-dashboard",
      icon: <FontAwesomeIcon icon={faComments} fontSize={14} />,
      subTitle: [
        {
          title: "Overview",
          path: "/",
          icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_OPS_DASHBOARD])) {
    menus.push({
      title: "Ops Dashboard",
      path: "/operations",
      icon: <FontAwesomeIcon icon={faTachometerAlt} fontSize={14} />,
      subTitle: [
        {
          title: "Ops-sync",
          path: "/ops-sync",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Operations",
          path: "/",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Urgent Sourcing",
          path: "/urgent-sourcing",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Stock Check",
          path: "/stock-check",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Sourcing",
          path: "/sourcing",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Quality Control",
          path: "/qc",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Mockups",
          path: "/mockups",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
        {
          title: "Vendors",
          path: "/vendors",
          icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_PARTNER_DASHBOARD])) {
    menus.push({
      title: "Partner Dashboard",
      path: "/partners",
      icon: <FontAwesomeIcon icon={faHandshake} fontSize={14} />,
    });
  }

  const sales_menu = [];
  if (userStore.hasPermission([EmployeeRoles.VIEW_SALES_DASHBOARD])) {
    sales_menu.push({
      title: "Overview",
      path: "/",
      icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
    });
    sales_menu.push({
      title: "Proposal",
      path: "/proposals",
      icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
    });
    sales_menu.push({
      title: "Lead Analytics",
      path: "/lead-analytics",
      icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_UNPAID_SAMPLES_DASHBOARD])) {
    sales_menu.push({
      title: "Unpaid Samples",
      path: "/unpaid-samples",
      icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
    });
  }

  if (
    userStore.hasPermission([
      EmployeeRoles.VIEW_SALES_DASHBOARD,
      EmployeeRoles.VIEW_UNPAID_SAMPLES_DASHBOARD,
    ])
  ) {
    menus.push({
      title: "Sales Dashboard",
      path: "/sales",
      icon: <FontAwesomeIcon icon={faDollarSign} fontSize={14} />,
      subTitle: sales_menu,
    });
  }

  //+++++++++++++++++++++++++++++++++++++

  menus.push({
    title: "Address",
    path: "/address",
    icon: <FontAwesomeIcon icon={faAddressCard} fontSize={12} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Add Address",
        path: "/add-edit-address",
        icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
      },
    ],
  });

  if (
    userStore.hasPermission([
      EmployeeRoles.VIEW_CUSTOMER,
      EmployeeRoles.CREATE_CUSTOMER,
      EmployeeRoles.EDIT_CUSTOMER,
    ])
  )
    menus.push({
      title: "Customers",
      path: "/customers",
      icon: <FontAwesomeIcon icon={faUserShield} fontSize={14} />,
      subTitle: userStore.hasPermission([
        EmployeeRoles.CREATE_CUSTOMER,
        EmployeeRoles.EDIT_CUSTOMER,
      ])
        ? [
          {
            title: "List",
            path: "/listing",
            icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
          },
          {
            title: "Add Customer",
            path: "/add-edit-customer",
            icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
          },
        ]
        : [
          {
            title: "List",
            path: "/listing",
            icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
          },
        ],
    });

  menus.push({
    title: "Leads",
    path: "/leads",
    icon: <FontAwesomeIcon icon={faUserPlus} fontSize={14} />,
  });

  menus.push({
    title: "Orders",
    path: "/orders",
    icon: <FontAwesomeIcon icon={faCartFlatbed} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Stock Check Requests",
        path: "/stock-check-requests",
        icon: <FontAwesomeIcon icon={faCodePullRequest} fontSize={12} />,
      },
      {
        title: "Project Requests",
        path: "/project-requests",
        icon: <FontAwesomeIcon icon={faCodePullRequest} fontSize={12} />,
      },
      {
        title: "Coupons",
        path: "/coupons",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "OneLink Requests",
        path: "/onelink-requests",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });
  menus.push({
    title: "Pod Order",
    path: "/pod-orders",
    icon: <FontAwesomeIcon icon={faBox} fontSize={14} />,
    subTitle: [
      {
        title: "Add Pod Order",
        path: "/add",
        icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
      },
      {
        title: " Allocated Orders",
        path: "/allocated-orders/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });
  menus.push({
    title: "Property",
    path: "/property",
    icon: <FontAwesomeIcon icon={faBuilding} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Add Property",
        path: "/create",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });

  menus.push({
    title: "Urgent Sourcing",
    path: "/urgent-sourcing",
    icon: <FontAwesomeIcon icon={faTriangleExclamation} fontSize={14} />,
    subTitle: [
      {
        title: " Product Requests",
        path: "/requests",
        icon: <FontAwesomeIcon icon={faCodePullRequest} fontSize={12} />,
      },
      {
        title: "Products",
        path: "/products",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });

  if (
    userStore.hasPermission([
      EmployeeRoles.VIEW_USER,
      EmployeeRoles.CREATE_USER,
      EmployeeRoles.EDIT_USER,
    ])
  ) {
    menus.push({
      title: "Users",
      path: "/users",
      icon: <FontAwesomeIcon icon={faUserTie} fontSize={14} />,
      subTitle: userStore.hasPermission([
        EmployeeRoles.CREATE_USER,
        EmployeeRoles.EDIT_USER,
      ])
        ? [
          {
            title: "List",
            path: "/listing",
            icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
          },
          {
            title: "Add User",
            path: "/add-edit-user",
            icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
          },
        ]
        : [
          {
            title: "List",
            path: "/listing",
            icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
          },
        ],
    });
  }

  if (
    userStore.hasPermission([
      EmployeeRoles.VIEW_EMAILERS,
      EmployeeRoles.SEND_EMAILERS,
    ])
  ) {
    menus.push({
      title: "Emailers",
      path: "/emailers",
      icon: <FontAwesomeIcon icon={faComments} fontSize={14} />,
      subTitle: [
        ...(userStore.hasPermission([EmployeeRoles.VIEW_EMAILERS])
          ? [
            {
              title: "Voucher Emailers",
              path: "/vouchers",
              icon: <FontAwesomeIcon icon={faFileAlt} fontSize={12} />,
            },
          ]
          : []),
        ...(userStore.hasPermission([EmployeeRoles.SEND_EMAILERS])
          ? [
            {
              title: "Send Vouchers",
              path: "/send-vouchers",
              icon: <FontAwesomeIcon icon={faGift} fontSize={12} />,
            },
          ]
          : []),
      ],
    });
  }

  menus.push({
    title: "Inventory",
    path: "/inventory",
    icon: <FontAwesomeIcon icon={faWarehouse} fontSize={13} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Shipments",
        path: "/shipments",
        icon: <FontAwesomeIcon icon={faTruckRampBox} fontSize={12} />,
      },
      {
        title: "Storage Cost Details",
        path: "/storage-cost-details",
        icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
      },
    ],
  });

  menus.push({
    title: "Projects",
    path: "/project-management",
    icon: <FontAwesomeIcon icon={faCartFlatbed} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Unpaid Samples",
        path: "/unpaid-samples",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      ...(userStore.hasPermission(EmployeeRoles.VIEW_ORDER)
        ? [
          {
            title: "Ops Sync",
            path: "/ops-sync?order_category=2&page_no=1&active=true",
            icon: <FontAwesomeIcon icon={faSync} fontSize={12} />,
          },
        ]
        : []),

    ],
  });

  menus.push({
    title: "Vouchers",
    path: "/vouchers",
    icon: <FontAwesomeIcon icon={faGift} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });

  menus.push({
    title: "Invoices",
    path: "/invoices",
    icon: <FontAwesomeIcon icon={faFileInvoice} fontSize={14} />,
    subTitle: [
      {
        title: "Order Invoices",
        path: "/order-invoices",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Vendor Invoices",
        path: "/vendor-invoices",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });

  menus.push({
    title: "Pr & Po",
    path: "/purchase",
    icon: <FontAwesomeIcon icon={faList} fontSize={14} />,
    subTitle: [
      {
        title: "Purchase Requests",
        path: "/requests/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      // {
      //   title: "Vendor Invoices",
      //   path: "/invoices",
      //   icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      // },
    ],
  });

  menus.push({
    title: "Vendors",
    path: "/vendors",
    icon: <FontAwesomeIcon icon={faUserAstronaut} fontSize={12} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Vendor Requests",
        path: "/requests",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "PO Report",
        path: "/po-report",
        icon: <FontAwesomeIcon icon={faFileAlt} fontSize={12} />,
      },
      // {
      //   title: "Add Vendor",
      //   path: "/add-edit-vendor",
      //   icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
      // },
    ],
  });

  menus.push({
    title: "Products",
    path: "/products",
    icon: <FontAwesomeIcon icon={faBox} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Add Product",
        path: "/add-edit-product",
        icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
      },
    ],
  });

  menus.push({
    title: "Categories",
    path: "/categories",
    icon: <FontAwesomeIcon icon={faTags} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
    ],
  });

  menus.push({
    title: "Swageazy Inventory",
    path: "/swageazy-inventory",
    icon: <FontAwesomeIcon icon={faBoxes} fontSize={14} />,
  });

  menus.push({
    title: "Employees",
    path: "/employee",
    icon: <FontAwesomeIcon icon={faPerson} fontSize={14} />,
  });

  menus.push({
    title: "Task Tracker",
    path: "/task-tracker",
    icon: <FontAwesomeIcon icon={faListCheck} fontSize={14} />,
    subTitle: [
      {
        title: "List",
        path: "/listing",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Add Task",
        path: "/add-edit-task",
        icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
      },
    ],
  });

  if (userStore.hasPermission([EmployeeRoles.VIEW_CAMPAIGNS])) {
    menus.push({
      title: "Campaigns",
      path: "/campaigns",
      icon: <FontAwesomeIcon icon={faBullhorn} fontSize={14} />,
      subTitle: [
        {
          title: "List",
          path: "/listing",
          icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_HRMS])) {
    menus.push({
      title: "HRMS",
      path: "/hrms",
      icon: <FontAwesomeIcon icon={faUserTie} fontSize={14} />,
      subTitle: [
        {
          title: "List",
          path: "/listing",
          icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
        },
        {
          title: "GetKnit Sync",
          path: "/getknit-sync",
          icon: <FontAwesomeIcon icon={faSync} fontSize={12} />,
        },
      ],
    });
  }

  if (userStore.hasPermission([EmployeeRoles.VIEW_SWAGSTORE])) {
    menus.push({
      title: "Swagstore",
      path: "/swagstore",
      icon: <FontAwesomeIcon icon={faList} fontSize={14} />,
      subTitle: [
        {
          title: "List",
          path: "/listing",
          icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
        },
        ...(userStore.hasPermission([EmployeeRoles.CREATE_SWAGSTORE])
          ? [
            {
              title: "Create Store",
              path: "/create-store",
              icon: <FontAwesomeIcon icon={faSquarePlus} fontSize={12} />,
            },
          ]
          : []),
      ],
    });
  }

  menus.push({
    title: "Tools",
    path: "/mockup-generator",
    icon: <FontAwesomeIcon icon={faLayerGroup} fontSize={12} />,
    subTitle: [
      {
        title: "Mockup Generator",
        path: "/",
        icon: <FontAwesomeIcon icon={faList} fontSize={12} />,
      },
      {
        title: "Mockup Config",
        path: "/mockup-config",
        icon: <FontAwesomeIcon icon={faTools} fontSize={12} />,
      },
    ],
  });

  const handleDrawerOpen = () => {
    setOpen((isOpen) => !isOpen);
  };

  const hideChrome =
    location.pathname === "/projects/ops-sync" ||
    location.pathname.includes("/swagstore/create-store") ||
    location.pathname.includes("/swagstore/preview");
  const isOpsSyncRoute = location.pathname === "/project-management/ops-sync";

  return (
    <>
      {!hideChrome && <Navbar handleMenuClick={handleDrawerOpen} />}
      <div className="wrapper">
        <AppSideDrawer
          open={open}
          handleDrawerClose={handleDrawerOpen}
          menus={menus}
        />
        <div
          className={`body ${open ? "sidebar-open" : "sidebar-closed"}`}
          style={{
            marginTop: hideChrome ? "0" : "56px",
            ...(isOpsSyncRoute
              ? {
                  display: "flex",
                  flexDirection: "column",
                  height: hideChrome ? "100vh" : "calc(100vh - 56px)",
                  minHeight: hideChrome ? "100vh" : "calc(100vh - 56px)",
                  overflow: "hidden",
                }
              : {}),
          }}
        >
          {!hideChrome && <QuickLinks />}
          {isOpsSyncRoute ? (
            <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
              <AppContent />
            </div>
          ) : (
            <AppContent />
          )}
        </div>
      </div>
    </>
  );
};

export default React.memo(DefaultLayout);
